import { removeStorage, setStorage, getStorage, clearStorage } from "@/utils";
import { Login } from "@/api/user";

const role = getStorage("role", 0);
const token = getStorage("token", 0);
const visitor = getStorage("visitor", 0); //游客 token
const account = getStorage("account", 0);
const userName = getStorage("userName", 0);
const huashi = getStorage("huashi", 0); //华师前台登录标识
const nickName = getStorage("nickName", 0);
const state = {
  token,
  role,
  account,
  visitor,
  userName,
  huashi,
  nickName,
};
const mutations = {
  SET_HUA_SHI: (state, value) => {
    state.huashi = value;
    setStorage("huashi", value, 0);
  },
  SET_TOKEN_KEY: (state, value) => {
    state.tokenKey = value;
  },
  SET_NICKNAME: (state, name) => {
    state.nickName = name;
    setStorage("nickName", name, 0);
  },
  SET_ROLE: (state, role) => {
    state.role = role;
    setStorage("role", role, 0);
  },
  SET_TOKEN: (state, token) => {
    state.token = token;
    setStorage("token", token, 0);
  },
  SET_DATABASE_TOKEN: (state, token) => {
    state.database_token = token;
    setStorage("database_token", token, 0);
  },
  SET_VISITOR: (state, visitor) => {
    state.visitor = visitor;
    setStorage("visitor", visitor, 0);
  },
  SET_ACCOUNT: (state, account) => {
    state.account = account;
    setStorage("account", account, 0);
  },
  // 设置用户名
  UPDATE_USER_NAME: (state, userName) => {
    state.userName = userName;
    setStorage("userName", userName, 0);
  },
  // 设置个人信息
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo;
    setStorage("userInfo", userInfo, 0);
  },
  // 清除个人信息
  REMOVE_USER_INFO(state) {
    state.userInfo = "";
    state.userName = "";
    removeStorage("userInfo");
    removeStorage("userName");
  },
};
const actions = {
  clearAccountInfo(context) {
    // clearStorage()
    context.commit("SET_TOKEN", "");
    context.commit("SET_ROLE", "");
    context.commit("SET_ACCOUNT", ""); // 游客
    context.commit("UPDATE_USER_NAME", ""); // userName清空
    context.commit("SET_HUA_SHI", "");
    context.commit("SET_VISITOR", "");
    context.commit("SET_NICKNAME", "");
    context.commit("SET_YOUKE", "");
    removeStorage("token");
    removeStorage("role");
    removeStorage("account");
    // context.commit('SET_TOKEN', getStorage('visitor', visitor, 0))
  },
  LoginForm(context, form) {
    return new Promise((resolve, reject) => {
      Login(form)
        .then((res) => {
          if (res.code === 200) {
            clearStorage();
            //context.dispatch("user/clearAccountInfo");
            if (res.userName !== "visitor@qq.com") {
              context.commit("SET_TOKEN", res.token);
              context.commit("SET_ROLE", res.role);
              context.commit("UPDATE_USER_NAME", res.userName);
              context.commit("SET_NICKNAME", res.nickName);
            } else {
              context.commit("SET_VISITOR", res.token);
              //context.commit('SET_YOUKE', res.youke)
            }
          }
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
